import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
const StyledSwitch = withStyles(theme => ({
  switchBase: {
    color: theme.palette.primary.main,
    '&$checked': {
      color: theme.palette.primary.main
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.primary.main
    }
  },
  checked: {},
  track: {}
}))(Switch);
export const StyledHeaderSwitch = ({
  isChecked,
  onToggle
}) => /*#__PURE__*/React.createElement(StyledSwitch, {
  checked: isChecked,
  onChange: event => onToggle(event.target.checked),
  name: "styled-switch"
});
export default StyledHeaderSwitch;